/**
 * Sub Navigation Link Bar Section Script
 * Handles active link state auto-detection and scroll-into-view on narrow viewports
 */
(function () {
  "use strict";

  function normalizePath(path) {
    if (!path) return "";
    return path.split("?")[0].split("#")[0].replace(/\/$/, "") || "/";
  }

  function initSubNavSection(section) {
    if (!section) return;

    const pills = section.querySelectorAll(".sub-nav__pill");
    const scrollContainer = section.querySelector(".sub-nav__scroll-container");
    const currentPath = normalizePath(window.location.pathname);

    let foundActiveMatch = false;

    // First, check if a pill explicitly matches the current browser URL
    pills.forEach(function (pill) {
      const href = pill.getAttribute("href");
      if (!href || href === "#" || href.startsWith("#")) return;

      try {
        const pillUrl = new URL(href, window.location.origin);
        const pillPath = normalizePath(pillUrl.pathname);

        if (pillPath && pillPath === currentPath) {
          foundActiveMatch = true;
          pills.forEach(function (otherPill) {
            if (!otherPill.hasAttribute("data-forced-active")) {
              otherPill.classList.remove("is-active");
              otherPill.removeAttribute("aria-current");
            }
          });
          pill.classList.add("is-active");
          pill.setAttribute("aria-current", "page");
        }
      } catch (e) {
        // Ignore malformed URLs
      }
    });

    // Auto-scroll the active pill into view on narrow screens
    const activePill = section.querySelector(".sub-nav__pill.is-active");
    if (activePill && scrollContainer) {
      // Small timeout to allow styles & layout to settle
      requestAnimationFrame(function () {
        const containerRect = scrollContainer.getBoundingClientRect();
        const pillRect = activePill.getBoundingClientRect();

        const isOffscreenLeft = pillRect.left < containerRect.left;
        const isOffscreenRight = pillRect.right > containerRect.right;

        if (isOffscreenLeft || isOffscreenRight) {
          const scrollLeftTarget =
            activePill.offsetLeft -
            scrollContainer.clientWidth / 2 +
            activePill.clientWidth / 2;

          scrollContainer.scrollTo({
            left: Math.max(0, scrollLeftTarget),
            behavior: "smooth",
          });
        }
      });
    }
  }

  function initAllSubNavs() {
    const sections = document.querySelectorAll(".sub-nav-section");
    sections.forEach(initSubNavSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSubNavs);
  } else {
    initAllSubNavs();
  }

  // Shopify Theme Editor support
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.classList.contains("sub-nav-section")) {
      initSubNavSection(event.target);
    } else if (event.target) {
      const navSection = event.target.querySelector(".sub-nav-section");
      if (navSection) initSubNavSection(navSection);
    }
  });

  document.addEventListener("shopify:section:select", function (event) {
    if (event.target && event.target.classList.contains("sub-nav-section")) {
      initSubNavSection(event.target);
    } else if (event.target) {
      const navSection = event.target.querySelector(".sub-nav-section");
      if (navSection) initSubNavSection(navSection);
    }
  });
})();
